export default "__VITE_ASSET__CnBTZ$AF__"